const colors = {
  BRAND_THEME: '#0B1833',
  BRAND_PRIMARY_ACTION: '#2369FF',
  BRAND_PRIMARY_BG: '#214796',
  BRAND_PRIMARY_GREEN: '#4BA345',
  BRAND_PRIMARY_RED: '#C94949',
  BRAND_PRIMARY_ORANGE: '#E68E00',
  BRAND_PRIMARY_WHITE: '#FFFFFF',
  BRAND_PRIMARY_WHITE_CLICKED: 'rgba(255, 255, 255, 0.5)',
  BRAND_PURE_BLACK: '#000000',
  BRAND_PRIMARY_BLACK: '#212121',
  BRAND_COLOR_GRAY_1: 'rgba(255, 255, 255, 0.7)',
  BRAND_COLOR_GRAY_2: 'rgba(255, 255, 255, 0.4)',
  BRAND_COLOR_GRAY_3: 'rgba(255, 255, 255, 0.16)',
  BRAND_COLOR_GRAY_4: 'rgba(255, 255, 255, 0.1)',
  BRAND_COLOR_GRAY_5: 'rgba(255, 255, 255, 0.08)',
  BRAND_COLOR_GRAY_6: 'rgba(255, 255, 255, 0.06)',
  BG_PRIMARY_SEPARATOR: 'rgba(255, 255, 255, 0.16)',
  BG_PRIMARY: 'rgba(11, 24, 51, 1)',
  BG_SECONDARY_SEPARATOR: 'rgba(255, 255, 255, 0.08)',
  BG_HOVER: 'rgba(255, 255, 255, 0.06)',
  BG_WHITE: 'rgba(255, 255, 255, 1)',
  BG_JIO: 'rgba(33, 71, 150, 1)',
  BG_PRIMARY_BUTTON: 'rgba(35, 105, 255, 1)',
  BG_PRIMARY_BUTTON_HOVER: 'rgba(77, 133, 255, 1)',
  BG_PRIMARY_BUTTON_CLICKED: 'rgba(33, 97, 235, 1)',
  BG_SECONDARY_BUTTON_HOVER: 'rgba(255, 255, 255, 0.06)',
  BG_SECONDARY_BUTTON_CLICKED: 'rgba(255, 255, 255, 0.12)',
  BG_TERTIARY_BUTTON: '',
  BG_TERTIARY_HOVER: 'rgba(35, 105, 255, 0.06)',
  BG_TERTIARY_CLICKED: 'rgba(35, 105, 255, 0.12)',
  BG_PRIMARY_DESTRUCTIVE: 'rgba(201, 73, 73, 1)',
  BG_SECONDAY_DESTRUCTIVE: 'rgba(201, 73, 73, 0.24)',
  BG_PRIMARY_PENDING: 'rgba(230, 142, 0, 1)',
  BG_SECONDARY_PENDING_HOVER: 'rgba(230, 142, 0, 0.24)',
  BG_PRIMARY_SUCCESS: 'rgba(75, 163, 69, 1)',
  BG_SECONDARY_SUCCESS: 'rgba(75, 163, 69, 0.24)',
  BG_PRIMARY_SEPARATOR_WHITE: 'rgba(255, 255, 255, 0.16)',
  BG_SECONDARY_SEPARATOR_WHITE: 'rgba(255, 255, 255, 0.1)',
  TEXT_PRIMARY: 'rgba(255, 255, 255, 1)',
  TEXT_SECONDARY: 'rgba(255, 255, 255, 0.7)',
  TEXT_TERTIARY: 'rgba(255, 255, 255, 0.4)',
  TEXT_LINK: 'rgba(35, 105, 255, 1)',
  TEXT_LINK_HOVER: 'rgba(77, 133, 255, 1)',
  TEXT_LINK_CLICKED: 'rgba(33, 97, 235, 1)',
  TEXT_ERROR: 'rgba(201, 73, 73, 1)',
  TEXT_PENDING: 'rgba(230, 142, 0, 1)',
  TEXT_SUCCESS: 'rgba(75, 163, 69, 1)',
  TEXT_INVERSE_PRIMARY: 'rgba(255, 255, 255, 1)',
  TEXT_INVERSE_SECONDARY: 'rgba(255, 255, 255, 0.7)',
  TEXT_INVERSE_TERTIARY: 'rgba(255, 255, 255, 0.54)',
  BORDER_TEXTFIELD: 'rgba(255, 255, 255, 0.7)',
  BORDER_PRIMARY: 'rgba(255, 255, 255, 0.16)',
  BORDER_DESTRUCTIVE: 'rgba(201, 73, 73, 1)',
  BORDER_PENDING: 'rgba(230, 142, 0, 1)',
  BORDER_SUCCESS: 'rgba(75, 163, 69, 1)',
  BORDER_SECONDARY_BUTTON: 'rgba(35, 105, 255, 1)',
  SHADOW_12: 'rgba(0, 0, 0, 0.32)',
  SHADOW_16: 'rgba(0, 0, 0, 0.48)',
}

const newThemeDark = {
  colors: colors,
}

export { newThemeDark }
